module.exports = __webpack_public_path__ + "img/8_63.e92e919a.png";